import { useEffect, useState } from 'react'
import batchedUpdates from 'lib/batched-updates'
let isLoad = false

type Subscriber = () => void

const subscribers = new Set<Subscriber>()

function handleLoad() {
  isLoad = true
  subscribers.forEach((subscriber) => {
    batchedUpdates(() => {
      subscriber()
    })
  })
}

if (typeof window !== 'undefined') {
  window.addEventListener('load', handleLoad)
}

function useWindowLoaded() {
  const [state, setState] = useState(isLoad)

  useEffect(() => {
    if (isLoad) return
    const subscriber = () => {
      setState(isLoad)
    }
    subscribers.add(subscriber)
    return () => {
      subscribers.delete(subscriber)
    }
  }, [])

  return state
}

export default useWindowLoaded
